import * as type from "../../types/API/authTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const loginReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.LOGIN_USER:
      return {
        ...state,
        loading: true,
      };
    case type.LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.LOGIN_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};


export const signupReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.SIGNUP_USER:
      return {
        ...state,
        loading: true,
      };
    case type.SIGNUP_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.SIGNUP_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const forgotPasswordReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.FORGOT_PASSWORD:
      return {
        ...state,
        loading: true,
        error:null,
      };
    case type.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const resetPasswordReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.RESET_PASSWORD:
      return {
        ...state,
        loading: true,
        error:null,
      };
    case type.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.RESET_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};